import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NxMessageToastService } from '@allianz/ng-aquila/message';
import { ToastMessageComponent } from '../components/toast-message/toast-message.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private messageToastService = inject(NxMessageToastService)
  error: WritableSignal<HttpErrorResponse | null> = signal(null);

  httpErrorResponseToast(error: HttpErrorResponse) {
    const status = error?.status;
    this.error.set(error);
    console.error(error);
    switch (status) {
      case 400:
        this.showMessage('Bad request. Please check the data sent and try again.');
        break;
      case 401:
        this.showMessage('Unauthorized. You do not have the necessary credentials to access this resource.');
        break;
      case 403:
        this.showMessage('Access denied. You do not have permission to access this resource.');
        break;
      case 404:
        if (!error.url?.includes('payments/pay')) {
          this.showMessage('The requested resource could not be found.');
        }
        break;
      case 409:
        this.showMessage('Conflict. The resource you are trying to access is in conflict with another resource.');
        break;
      case 422:
        if (!error.url?.includes('payments/pay') || error.error.errorCode !== "PAYMENT_ALREADY_DONE") {
          this.showMessage('Service currently unavailable. Please try again later.');
        }
        break;
      default:
        if (error?.error?.details?.statusCode !== 402) {
          this.showMessage('Service currently unavailable. Please try again later.');
        }
    }
  }

  showMessage(message: string) {
    this.messageToastService.openFromComponent(
      ToastMessageComponent,
      {
        duration: 5000,
        // @ts-expect-error context is not defined in library
        context: 'error',
        data: {
          title: 'Oops, an error occurred',
          message
        }
      },
    );
  }
}
